// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__21Mb0","rootNoMargin":"styles_rootNoMargin__3iaTS"};